import { CreateConversationPayload } from "@rms-types/modules/conversation/dto";
import { Conversation } from "@rms-types/modules/conversation/entities/conversation";
import { useSnackbar } from "notistack";

import { conversationEndpoint } from "@/constants";
import { usePost, UsePostOptions } from "@/hooks";

interface UseCreateConversation {
  subdomain?: string | null;
  options: UsePostOptions<Conversation, CreateConversationPayload>;
}

export function useCreateConversation({ subdomain, options }: UseCreateConversation) {
  const endpoint = subdomain
    ? conversationEndpoint.getExternalConversation(subdomain)
    : conversationEndpoint.conversation;
  const { enqueueSnackbar } = useSnackbar();

  const {
    mutate: createConversation,
    error: createConversationError,
    isPending: isCreateConversationPending,
    ...rest
  } = usePost<Conversation, CreateConversationPayload>({
    endpoint,
    options: {
      ...options,
      onSuccess: (data, variables, context) => {
        options?.onSuccess && options.onSuccess(data, variables, context);
        enqueueSnackbar("Message sent", { variant: "success" });
      },
      onError: (error, variables, context) => {
        options.onError && options.onError(error, variables, context);
        enqueueSnackbar("Failed to send the message", { variant: "error" });
      },
    },
  });

  return {
    createConversation,
    createConversationError,
    isCreateConversationPending,
    ...rest,
  };
}
